import React from 'react';
import { Drawer } from 'antd';
import { usePipelinesOverview } from '../../../core/modules/pipelines/hooks';
import PipelineDetailView from './PipelineDetailView';

interface IPipelineDetailDrawerProps {
  pipelineId: string | null;
  onClose: () => void;
}

const PipelineDetailDrawer: React.FC<IPipelineDetailDrawerProps> = ({ pipelineId, onClose }) => {
  const { data } = usePipelinesOverview();
  const summary = data?.data.pipelines?.find((p) => p.id === pipelineId);

  return (
    <Drawer
      placement='right'
      width={Math.min(820, typeof window !== 'undefined' ? window.innerWidth - 80 : 820)}
      onClose={onClose}
      visible={Boolean(pipelineId)}
      destroyOnClose
      closable={false}
      bodyStyle={{ background: '#fafafa', padding: '20px 24px' }}
    >
      {pipelineId && summary && (
        <PipelineDetailView
          pipelineId={pipelineId}
          scheduleHuman={summary.schedule}
          displayName={summary.name}
          description={summary.description ?? null}
          onClose={onClose}
        />
      )}
    </Drawer>
  );
};

export default PipelineDetailDrawer;
